import {configureStore} from '@reduxjs/toolkit'
import dashboard from './slicer/dashboard'
import common from './slicer/common'

export default configureStore({
  reducer: {dashboard, common},
})
